export const listIndexesAndListFields = (context?: any) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.readings.listIndexesAndListFields(
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadReadingMetadata = (
  thingId: number,
  parameterId: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.readings.loadReadingMetadata(
      thingId,
      parameterId,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadReadingMetadataDetails = (
  thingId: number,
  parameterId: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.readings.loadReadingMetadataDetails(
      thingId,
      parameterId,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadReadingsAtTimestamp = (
  ts: number,
  ou: number,
  parameterArray: number[],
  thingArray: number[],
  filterContextValue: string,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.readings.loadReadingsAtTimestamp(
      ts,
      ou,
      parameterArray,
      thingArray,
      filterContextValue,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const loadReadings = (
  start: number,
  end: number,
  ou: number,
  parameter: number,
  thingId: number,
  ascending: boolean,
  limit: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.readings.loadReadings(
      start,
      end,
      ou,
      parameter,
      thingId,
      ascending,
      limit,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}

export const deleteReadings = (
  startTS: number,
  endTS: number,
  parameter: number,
  thing: number,
  context?: any
) => {
  return new Promise((resolve, reject) => {
    window.parent.primingcloud.readings.deleteReadings(
      startTS,
      endTS,
      parameter,
      thing,
      (data: unknown) => resolve(data),
      context ? context : null
    )
  })
}
